import { TabConstants } from '../components/tabs/Tabs.constants'

export const INTERNAL_PICKLIST_ROUTES: ReadonlySet<string> = new Set<string>([
  // ccHpi
  TabConstants.CC_HPI_INJURY_CAUSE,

  // Initial assessments
  TabConstants.INITIAL_ASSESSMENT_COMMENTS,
  TabConstants.GLASSGOW_COMMA_SCORE,
  TabConstants.PEDIATRIC_TRAUMA_SCORE,
  TabConstants.REVISED_TRAUMA_SCORE,
  TabConstants.STROKE_SCORE,

  // Vitals sub-pages
  TabConstants.VITALS_STROKE_SCORE,
  TabConstants.VITALS_PAIN_QUALITY,
  TabConstants.VITALS_PAIN_SCALES,
  TabConstants.VITALS_SEDATION_SCALE,
  TabConstants.VITALS_WITHDRAWAL_SCALES,

  // Patient demographics sub-pages
  TabConstants.DO_NOT_RESUSCITATE,
  TabConstants.BARRIERS_TO_CARE,
  TabConstants.PREFERRED_LANGUAGE,
])

export const isInternalPicklistRoute = (pathname: string): boolean => INTERNAL_PICKLIST_ROUTES.has(pathname)
